<template>
  <div>
    <div class="layoutJSON">
      Displayed as <code>[x, y, w, h]</code>:
      <div class="columns">
        <div class="layoutItem" v-for="item in layout" :key="item.i">
          <b>{{ item.i }}</b
          >: [{{ item.x }}, {{ item.y }}, {{ item.w }}, {{ item.h }}]
        </div>
      </div>
    </div>
    <button @click="addItem">Add an item dynamically</button>
    <input type="checkbox" v-model="draggable" /> Draggable
    <input type="checkbox" v-model="resizable" /> Resizable
    <div class="ut-fh">
      <grid-layout
        :layout.sync="gridLayout.layout"
        :col-num="60"
        :row-height="6"
        :is-draggable="true"
        :is-resizable="true"
        :vertical-compact="true"
        :use-css-transforms="true"
        ref="gridLayout"
      >
        <grid-item
          v-for="item in gridLayout.layout"
          :static="item.static"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :key="item.i"
        >
          <template v-if="item.i == 'submenu_GROUPS'">
            <BoxWidget
              :isPinnable="true"
              @pin="onBoxPinned"
              @selected="selectBox"
              @minimized="onMinimize"
              @maximized="onMaximize"
              :layoutItem="gdi('product_setup')"
            >
            </BoxWidget>
          </template>
          <template v-else-if="item.i == 'only_tracks'">
            <BoxWidget
              :isPinnable="true"
              @pin="onBoxPinned"
              @selected="selectBox"
              @minimized="onMinimize"
              @maximized="onMaximize"
              :layoutItem="gdi('only_tracks')"
            >
            </BoxWidget>
          </template>
          <template v-else-if="item.i == 'accounts'">
            <BoxWidget
              :isPinnable="true"
              @pin="onBoxPinned"
              @selected="selectBox"
              @minimized="onMinimize"
              @maximized="onMaximize"
              :layoutItem="gdi('accounts')"
            >
            </BoxWidget>
          </template>
          <template v-else>
            <span class="text">{{ item.i }}</span>
            <span class="remove" @click="removeItem(item.i)">x</span>
          </template>
        </grid-item>
      </grid-layout>
    </div>
  </div>
</template>
<script>
import BoxWidget from "@plugins/box-widget/box-widget";

import { GridLayout, GridItem } from "vue-grid-layout";
import {
  createGridItem,
  createGridLayout,
} from "../../store/global/gridlayout";
import { createGridHost } from "../../dt-plugins/sidewindow";
export default {
  components: {
    GridLayout,
    GridItem,
    BoxWidget,
  },
  mixins: [
    createGridHost({
      layoutName: "gridLayout",
      gridRef: "gridLayout",
    }),
  ],
  data() {
    return {
      draggable: true,
      resizable: true,
      colNum: 60,
      index: 0,
      layout: [
        createGridItem({
          x: 0,
          y: 0,
          w: 30,
          h: 15,
          i: "product_setup",
        }),
        createGridItem({
          x: 30,
          y: 0,
          w: 30,
          h: [10.3, 22],
          i: "advanced_product_setup",
        }),
        createGridItem({
          x: 30,
          y: 10,
          w: 30,
          h: 4.7,
          i: "stock_location",
        }),
        createGridItem({
          x: 0,
          y: 15,
          w: 30,
          h: 15,
          i: "prices",
        }),
        createGridItem({
          x: 30,
          y: 20.3,
          w: 30,
          h: 15,
          i: "submenu_GROUPS",
        }),
        createGridItem({
          x: 0,
          y: 35,
          w: 60,
          h: 15,
          i: "only_tracks",
        }),
        createGridItem({
          x: 0,
          y: 30,
          w: 60,
          h: 15,
          i: "accounts",
        }),
        createGridItem({
          x: 0,
          y: 45,
          w: 30,
          h: 10,
          i: "notes",
        }),
        createGridItem({
          x: 0,
          y: 55,
          w: 60,
          h: 5,
          i: "tab_title_tracks",
        }),
        createGridItem({
          x: 0,
          y: 60,
          w: 60,
          h: 15,
          i: "tracklisting",
        }),
        createGridItem({
          x: 0,
          y: 75,
          w: 60,
          h: 15,
          i: "GEMA",
        }),
        createGridItem({
          x: 0,
          y: 90,
          w: 60,
          h: 5,
          i: "tab_title_infos",
        }),
        createGridItem({
          x: 0,
          y: 95,
          w: 35,
          h: 11.6,
          i: "product_information",
        }),
        createGridItem({
          x: 35,
          y: 95,
          w: 25,
          h: 11.6,
          i: "related_files",
        }),
        createGridItem({
          x: 0,
          y: 106.6,
          w: 35,
          h: 21,
          i: "artwork_cover",
        }),
        createGridItem({
          x: 0,
          y: 127.6,
          w: 60,
          h: 4,
          i: "tab_title_costs",
        }),
        createGridItem({
          x: 0,
          y: 131.6,
          w: 60,
          h: 3,
          i: "cost_account_all",
        }),
        createGridItem({
          x: 0,
          y: 134.6,
          w: 60,
          h: 20,
          i: "related_costs",
        }),
        createGridItem({
          x: 0,
          y: 154.6,
          w: 60,
          h: 5,
          i: "other_income",
        }),
        createGridItem({
          x: 0,
          y: 159.6,
          w: 60,
          h: 20,
          i: "related_other_income",
        }),
        createGridItem({
          x: 0,
          y: 179.6,
          w: 60,
          h: 5,
          i: "royalty",
        }),

        createGridItem({
          x: 0,
          y: 184.6,
          w: 60,
          h: 5,
          i: "royalty_btn",
        }),

        createGridItem({
          x: 0,
          y: 189.6,
          w: 60,
          h: 15,
          i: "royalties",
        }),
        createGridItem({
          x: 0,
          y: 204.6,
          w: 60,
          h: 5,
          i: "sales",
        }),
        createGridItem({
          x: 0,
          y: 209.6,
          w: 60,
          h: 20,
          i: "ds_sales",
        }),
        createGridItem({
          x: 0,
          y: 229.6,
          w: 60,
          h: 5,
          i: "stock",
        }),
        createGridItem({
          x: 0,
          y: 234.6,
          w: 30,
          h: 30,
          i: "stock_levels",
        }),
        createGridItem({
          x: 30,
          y: 234.6,
          w: 30,
          h: 13,
          i: "manufacturing",
        }),
        createGridItem({
          x: 30,
          y: 254.6,
          w: 30,
          h: 13,
          i: "open_orders",
        }),
        createGridItem({
          x: 30,
          y: 254.6,
          w: 30,
          h: 13,
          i: "backorders",
        }),
        createGridItem({
          x: 0,
          y: 274.6,
          w: 60,
          h: 5,
          i: "specials",
        }),
        createGridItem({
          x: 0,
          y: 279.6,
          w: 35,
          h: 20,
          i: "country_restrictions",
        }),
        createGridItem({
          x: 35,
          y: 299.6,
          w: 25,
          h: 20,
          i: "manual_matches",
        }),
        createGridItem({
          x: 0,
          y: 299.6,
          w: 30,
          h: 6.5,
          i: "harry_fox",
        }),
        createGridItem({
          x: 0,
          y: 309.6,
          w: 60,
          h: 5,
          i: "metadata",
        }),
        createGridItem({
          x: 0,
          y: 314.6,
          w: 30,
          h: 60,
          i: "meta_data",
        }),
      ],
      gridLayout: createGridLayout({
        layout: [
          createGridItem({
            x: 0,
            y: 0,
            w: 30,
            h: 15,
            i: "product_setup",
          }),
          createGridItem({
            x: 30,
            y: 0,
            w: 30,
            h: [10.3, 22],
            i: "advanced_product_setup",
          }),
          createGridItem({
            x: 30,
            y: 10,
            w: 30,
            h: 4.7,
            i: "stock_location",
          }),
          createGridItem({
            x: 0,
            y: 15,
            w: 30,
            h: 15,
            i: "prices",
          }),
          createGridItem({
            x: 30,
            y: 20.3,
            w: 30,
            h: 15,
            i: "submenu_GROUPS",
          }),
          createGridItem({
            x: 0,
            y: 35,
            w: 60,
            h: 15,
            i: "only_tracks",
          }),
          createGridItem({
            x: 0,
            y: 30,
            w: 60,
            h: 15,
            i: "accounts",
          }),
          createGridItem({
            x: 0,
            y: 45,
            w: 30,
            h: 10,
            i: "notes",
          }),
          createGridItem({
            x: 0,
            y: 55,
            w: 60,
            h: 5,
            i: "tab_title_tracks",
          }),
          createGridItem({
            x: 0,
            y: 60,
            w: 60,
            h: 15,
            i: "tracklisting",
          }),
          createGridItem({
            x: 0,
            y: 75,
            w: 60,
            h: 15,
            i: "GEMA",
          }),
          createGridItem({
            x: 0,
            y: 90,
            w: 60,
            h: 5,
            i: "tab_title_infos",
          }),
          createGridItem({
            x: 0,
            y: 95,
            w: 35,
            h: 11.6,
            i: "product_information",
          }),
          createGridItem({
            x: 35,
            y: 95,
            w: 25,
            h: 11.6,
            i: "related_files",
          }),
          createGridItem({
            x: 0,
            y: 106.6,
            w: 35,
            h: 21,
            i: "artwork_cover",
          }),
          createGridItem({
            x: 0,
            y: 127.6,
            w: 60,
            h: 4,
            i: "tab_title_costs",
          }),
          createGridItem({
            x: 0,
            y: 131.6,
            w: 60,
            h: 3,
            i: "cost_account_all",
          }),
          createGridItem({
            x: 0,
            y: 134.6,
            w: 60,
            h: 20,
            i: "related_costs",
          }),
          createGridItem({
            x: 0,
            y: 154.6,
            w: 60,
            h: 5,
            i: "other_income",
          }),
          createGridItem({
            x: 0,
            y: 159.6,
            w: 60,
            h: 20,
            i: "related_other_income",
          }),
          createGridItem({
            x: 0,
            y: 179.6,
            w: 60,
            h: 5,
            i: "royalty",
          }),

          createGridItem({
            x: 0,
            y: 184.6,
            w: 60,
            h: 5,
            i: "royalty_btn",
          }),

          createGridItem({
            x: 0,
            y: 189.6,
            w: 60,
            h: 15,
            i: "royalties",
          }),
          createGridItem({
            x: 0,
            y: 204.6,
            w: 60,
            h: 5,
            i: "sales",
          }),
          createGridItem({
            x: 0,
            y: 209.6,
            w: 60,
            h: 20,
            i: "ds_sales",
          }),
          createGridItem({
            x: 0,
            y: 229.6,
            w: 60,
            h: 5,
            i: "stock",
          }),
          createGridItem({
            x: 0,
            y: 234.6,
            w: 30,
            h: 30,
            i: "stock_levels",
          }),
          createGridItem({
            x: 30,
            y: 234.6,
            w: 30,
            h: 13,
            i: "manufacturing",
          }),
          createGridItem({
            x: 30,
            y: 254.6,
            w: 30,
            h: 13,
            i: "open_orders",
          }),
          createGridItem({
            x: 30,
            y: 254.6,
            w: 30,
            h: 13,
            i: "backorders",
          }),
          createGridItem({
            x: 0,
            y: 274.6,
            w: 60,
            h: 5,
            i: "specials",
          }),
          createGridItem({
            x: 0,
            y: 279.6,
            w: 35,
            h: 20,
            i: "country_restrictions",
          }),
          createGridItem({
            x: 35,
            y: 299.6,
            w: 25,
            h: 20,
            i: "manual_matches",
          }),
          createGridItem({
            x: 0,
            y: 299.6,
            w: 30,
            h: 6.5,
            i: "harry_fox",
          }),
          createGridItem({
            x: 0,
            y: 309.6,
            w: 60,
            h: 5,
            i: "metadata",
          }),
          createGridItem({
            x: 0,
            y: 314.6,
            w: 30,
            h: 60,
            i: "meta_data",
          }),
        ],
      }),
    };
  },
  mounted() {
    // this.$gridlayout.load();
    this.index = this.layout.length;

    setTimeout(() => {
      this.gridLayout = {
        ...this.gridLayout,
        layout: this.gridLayout.layout.filter((e) => e.i != "accounts"),
      };
    }, 5000);
  },
  methods: {
    addItem: function () {
      // Add a new item. It must have a unique key!
      this.layout.push({
        x: (this.layout.length * 2) % (this.colNum || 12),
        y: this.layout.length + (this.colNum || 12), // puts it at the bottom
        w: 2,
        h: 2,
        i: this.index,
      });
      // Increment the counter to ensure key is always unique.
      this.index++;
    },
    removeItem: function (val) {
      // const index = this.layout.map((item) => item.i).indexOf(val);
      // this.layout.splice(index, 1);

      this.gridLayout = {
        ...this.gridLayout,
        layout: this.gridLayout.layout.filter((e) => e.i != val),
      };
    },
  },
};
</script>

<style>
.layoutJSON {
  background: #ddd;
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}
.columns {
  -moz-columns: 120px;
  -webkit-columns: 120px;
  columns: 120px;
}
/*************************************/
.remove {
  position: absolute;
  right: 2px;
  top: 0;
  cursor: pointer;
}
.vue-grid-layout {
  background: #eee;
}
.vue-grid-item:not(.vue-grid-placeholder) {
  background: #ccc;
  border: 1px solid black;
}
.vue-grid-item .resizing {
  opacity: 0.9;
}
.vue-grid-item .static {
  background: #cce;
}
.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}
.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}
.vue-grid-item .minMax {
  font-size: 12px;
}
.vue-grid-item .add {
  cursor: pointer;
}
.vue-draggable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
    no-repeat;
  background-position: bottom right;
  padding: 0 8px 8px 0;
  background-repeat: no-repeat;
  background-origin: content-box;
  box-sizing: border-box;
  cursor: pointer;
}
</style>